import { getProfile } from "api/services/users";
import Loader from "components/Loader";
import { snack } from "components/toast";
import { createContext, useContext, useEffect } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { ResType } from "types";

export const UserProfileContext = createContext<any>(null);

function UserProfileProvider({ children }) {
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const { data, isLoading, error }: ResType = useQuery(["user"], getProfile, {
    enabled: (!!localStorage.getItem("userId") && localStorage.getItem("isLogIn") === "true"),
  });


  useEffect(() => {
    // if (currentUrl != `${window.location.origin}/storage/cloud-storage/one-drive`) {
    if (window.location.href.includes(`${window.location.origin}/storage/cloud-storage`)) {
      // console.log("UserProfile data:", data?.data?.imageStorage);
      if (data?.data?.imageStorage?.error == 'invalid_grant') {
        snack.error("Drive Authentication error. Redirecting...3");
        navigate("/storage/cloud-storage");
      }
    }

    // if(!(!!localStorage.getItem("userId") && localStorage.getItem("isLogIn") === "true")){
    //   navigate("/login")
    // }

  }, [data])



  if (isLoading) return <Loader minHeight="60vh" />;

  return (
    <UserProfileContext.Provider value={{ data: data?.data, isLoading, error }}>
      {children}
    </UserProfileContext.Provider>
  );
}

export const useUserData = () => useContext(UserProfileContext);

export default UserProfileProvider;
